export const CONTROLER_ACTION_KEYS = {
    SORT_PARTICIPANTS_CTH: 'SORT_PARTICIPANTS_CTH'
};
